// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__vs6l4","flex":"panel_flex__8edld","box":"panel_box__tWVSo"};